// The menu's name for focus mode `modeId` (e.g. "Proposals Focus"), or null
// for General Focus, which shows no chip anywhere, and for a mode not in
// `modes` (the list GET /focus-modes returns).
export function focusModeDisplayName(modes, modeId) {
  if (!modeId || modeId === 'default') return null;
  return (modes || []).find((mode) => mode.id === modeId)?.name || null;
}

// Whether a conversation's focus mode tag (the API's `focus_mode`) matches a
// lowercased search: its full name ("3190 346 Madison II", "Proposals Focus")
// or its job number ("3190"), so typing either finds the rows with that tag.
export function focusModeTagMatches(focusMode, searchText) {
  if (!focusMode || !searchText) return false;
  return [focusMode.name, focusMode.short]
    .some((text) => typeof text === 'string' && text.toLowerCase().includes(searchText));
}
